import React, { useEffect, useRef, useState } from 'react';
import { useLocation } from "react-router-dom";
import { useSelector } from 'react-redux';
import editIcon from '../../../assets/icons/icon-edit.svg';

const EditButton = ({ showPage, section }: Props) => {

    // TODO: test this file, check if editing is working fine or not

    const location = useLocation();

    const editButton = useRef(null);

    const [isMobile, setIsMobile] = useState(false);
    
    useEffect(() => {
        const handleResize = () => {
            const isMobile = window?.innerWidth < 768;
    
            setIsMobile(isMobile);
        };
    
        handleResize(); // Call on initial render
    
        window?.addEventListener('resize', handleResize);
    
        return () => window?.removeEventListener('resize', handleResize);
    }, []);
    
    
    const therapistallPages = useSelector(
        (state) => state?.questionnaireData?.clientMetaData
    );
    
    const { loggedInUser } = useSelector(
        ({ authentication }) => authentication
    );
    
    const [isEditButtonVisible, setIsEditButtonVisible] = useState(true);
    
    useEffect(() => {
    
        if (loggedInUser.id !== therapistallPages.id) {
            return setIsEditButtonVisible(false);
        }
    
        setIsEditButtonVisible(true);
    }, [loggedInUser, therapistallPages]);
    
    useEffect(() => {
        const el: HTMLElement = editButton?.current?.closest(".sub-section") || editButton?.current?.closest(".therapist-profile__container");
    
        if (el !== undefined) {
            el?.addEventListener("mouseover", () => {
                if (editButton?.current?.style) {
                    editButton.current.style.visibility = 'visible';
                }
            });
            el?.addEventListener("mouseleave", () => {
                if (editButton?.current?.style) {
                    editButton.current.style.visibility = 'hidden';
                }
            });
        }
    }, []);
    
        const RenderEditButton = () => {
            const isPracticeAdmin = loggedInUser?.user_type?.includes("PRACTICE_ADMIN");
        
         
    if ((isEditButtonVisible || (location.pathname?.includes('profile/') && isPracticeAdmin)) && showPage){
                return (<div ref={editButton} onClick={() => showPage(section?.id)} 
                className='edit_profile_btn'>
                <img src={editIcon} alt='edit icon' 
                className='icon' />
                <div className='edit-txt'>Edit</div>
                </div>
                );
            }
            else return <></>;
        };
    
    return isMobile ? <></> : <RenderEditButton />;
    };
    
    export default  EditButton;



